import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@99designs/common/components/Alert';
import { Icon } from '@99designs/common/components/Icon';
import IneligibleContestAlert from './IneligibleContestAlert';
import RemainingInvitesMessage from './RemainingInvitesMessage';

export default class InviteAlert extends React.Component {
    errorAlert() {
        if (!this.props.errorMessage) return null;
        return (
            <Alert
                variations={['error']}
                icon={<Icon variations={['exclamation-point-2', 'offset-right']} />}
            >
                {this.props.errorMessage}
            </Alert>
        );
    }

    ineligibilityAlert() {
        if (this.props.isEligible) return null;
        return (
            <IneligibleContestAlert
                className={this.props.ineligibilityReason.class}
                iconName={this.props.ineligibilityReason.icon}
                linkUrl={this.props.ineligibilityReason.link}
                message={this.props.ineligibilityReason.message}
                linkMessage={this.props.ineligibilityReason.link_message}
            />
        );
    }

    noInvitesLeftAlert() {
        if (this.props.remainingInvites > 0) return null;

        return (
            <RemainingInvitesMessage
                remainingInvites={this.props.remainingInvites}
                timeRemaining={this.props.timeRemaining}
            />
        );
    }

    render() {
        return (
            <div>
                {this.ineligibilityAlert()}
                {this.noInvitesLeftAlert()}
                {this.errorAlert()}
            </div>
        );
    }
}

InviteAlert.defaultProps = {
    ineligibilityReason: {},
    errorMessage: '',
};

InviteAlert.propTypes = {
    remainingInvites: PropTypes.number.isRequired,
    timeRemaining: PropTypes.string.isRequired,
    isEligible: PropTypes.bool.isRequired,
    ineligibilityReason: PropTypes.shape({
        class: PropTypes.string,
        icon: PropTypes.string,
        link: PropTypes.string,
        message: PropTypes.string,
        link_message: PropTypes.string,
    }),
    errorMessage: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/js/apps/invite-designer/components/InviteAlert.jsx